import { Skeleton } from "@prosights/ui/components/skeleton";

export function PageLoading() {
  return (
    <div className="page-loading" aria-label="Loading workbench">
      <Skeleton className="h-6 w-56" />
      <Skeleton className="h-20 w-full" />
      <Skeleton className="h-64 w-full" />
    </div>
  );
}
